document.addEventListener('DOMContentLoaded', function () {
    document.addEventListener('submit', function (e) {
        const form = e.target;

        // LOGIN
        if (form.matches('.woocommerce-form-login')) {
            let valid = true;
            const loginInput = form.querySelector('#username');
            const passInput  = form.querySelector('#password');

            const loginErr = form.querySelector('[data-error-for="login"]');
            const passErr  = form.querySelector('[data-error-for="password"]');

            if (!loginInput.value.trim()) {
                valid = false;
                loginInput.setAttribute('aria-invalid', 'true');
                if (loginErr) loginErr.textContent = 'Вкажіть логін (телефон або email).';
            } else {
                loginInput.removeAttribute('aria-invalid');
                if (loginErr) loginErr.textContent = '';
            }

            if (!passInput.value.trim()) {
                valid = false;
                passInput.setAttribute('aria-invalid', 'true');
                if (passErr) passErr.textContent = 'Вкажіть пароль.';
            } else {
                passInput.removeAttribute('aria-invalid');
                if (passErr) passErr.textContent = '';
            }

            if (!valid) e.preventDefault();
        }

        // REGISTER
        if (form.matches('.woocommerce-form-register')) {
            let valid = true;

            const emailInput = form.querySelector('#reg_email');
            const phoneInput = form.querySelector('#reg-phone');
            const pwdInput   = form.querySelector('#reg-password');

            const emailErr = form.querySelector('[data-error-for="email"]');
            const phoneErr = form.querySelector('[data-error-for="phone"]');
            const pwdErr   = form.querySelector('[data-error-for="password"]');

            // email
            const emailVal   = emailInput.value.trim();
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

            if (!emailVal) {
                valid = false;
                emailInput.setAttribute('aria-invalid', 'true');
                if (emailErr) emailErr.textContent = 'Вкажіть електронну пошту.';
            } else if (!emailRegex.test(emailVal)) {
                valid = false;
                emailInput.setAttribute('aria-invalid', 'true');
                if (emailErr) emailErr.textContent = 'Вкажіть коректну електронну пошту.';
            } else {
                emailInput.removeAttribute('aria-invalid');
                if (emailErr) emailErr.textContent = '';
            }

            // phone
            const phoneRaw = phoneInput.value.replace(/\D/g, '');
            if (!phoneRaw) {
                valid = false;
                phoneInput.setAttribute('aria-invalid', 'true');
                if (phoneErr) phoneErr.textContent = 'Вкажіть номер телефону.';
            } else if (phoneRaw.length !== 9) {
                valid = false;
                phoneInput.setAttribute('aria-invalid', 'true');
                if (phoneErr) phoneErr.textContent = 'Номер телефону має містити 9 цифр.';
            } else {
                phoneInput.removeAttribute('aria-invalid');
                if (phoneErr) phoneErr.textContent = '';
            }

            // password validation
            const val       = pwdInput.value;
            const hasLength = val.length >= 8;
            const hasDigit  = /\d/.test(val);
            const hasUpper  = /[A-ZА-ЯЇІЄЎҐ]/u.test(val);
            const strong    = hasLength && hasDigit && hasUpper;

            if (!val.length) {
                valid = false;
                pwdInput.setAttribute('aria-invalid', 'true');
                if (pwdErr) pwdErr.textContent = 'Вкажіть пароль.';
            } else if (!strong) {
                valid = false;
                pwdInput.setAttribute('aria-invalid', 'true');
                if (pwdErr) pwdErr.textContent = 'Пароль має містити мінімум 8 символів, цифри та великі літери.';
            } else {
                pwdInput.removeAttribute('aria-invalid');
                if (pwdErr) pwdErr.textContent = '';
            }

            if (!valid) e.preventDefault();
        }
    });

    const pwdInput  = document.getElementById('reg-password');
    const pwdMeter  = document.querySelector('.auth-password-meter');
    const pwdLabel  = pwdMeter ? pwdMeter.querySelector('.auth-password-meter__label') : null;
    const pwdSegments = pwdMeter ? pwdMeter.querySelectorAll('.segment') : null;
    const pwdRules  = document.querySelectorAll('.auth-password-rule');

    function updatePasswordStrength() {
        if (!pwdInput || !pwdMeter || !pwdLabel || !pwdSegments) return;

        const val = pwdInput.value;
        const hasLength = val.length >= 8;
        const hasDigit  = /\d/.test(val);
        const hasUpper  = /[A-ZА-ЯЇІЄЎҐ]/u.test(val);

        let score = 0;
        pwdRules.forEach(ruleEl => {
            const rule = ruleEl.dataset.rule;
            let ok = false;
            if (rule === 'length') ok = hasLength;
            if (rule === 'digits') ok = hasDigit;
            if (rule === 'letters') ok = hasUpper;
            if (ok) {
                ruleEl.classList.add('is-valid');
                score++;
            } else {
                ruleEl.classList.remove('is-valid');
            }
        });

        pwdSegments.forEach(seg => seg.classList.remove('is-filled'));
        pwdLabel.classList.remove('is-filled');

        if (!val.length) {
            pwdLabel.textContent = 'Введіть пароль';
            return;
        }

        const segmentsToFill = Math.min(score + 1, pwdSegments.length);
        for (let i = 0; i < segmentsToFill; i++) {
            pwdSegments[i].classList.add('is-filled');
        }

        if (score < 1) {
            pwdLabel.textContent = 'Дуже слабкий';
            pwdLabel.classList.add('is-filled');
        } else if (score < 2) {
            pwdLabel.textContent = 'Слабкий';
            pwdLabel.classList.add('is-filled');
        } else if (score === 2) {
            pwdLabel.textContent = 'Нормальний';
            pwdLabel.classList.add('is-filled');
        } else {
            pwdLabel.textContent = 'Надійний';
            pwdLabel.classList.add('is-filled');
        }
    }

    if (pwdInput) {
        pwdInput.addEventListener('input', updatePasswordStrength);
    }

    const regForm = document.querySelector('.woocommerce-form-register');
    if (regForm) {
        const emailInput = regForm.querySelector('#reg_email');
        const phoneInput = regForm.querySelector('#reg-phone');
        const regPwdInput = regForm.querySelector('#reg-password');

        function clearErrorOnInput(input, errorName, extraCheckFn) {
            if (!input) return;
            input.addEventListener('input', function () {
                const error = regForm.querySelector(`[data-error-for="${errorName}"]`);
                const ok = extraCheckFn ? extraCheckFn(input.value) : !!input.value.trim();
                if (ok) {
                    input.removeAttribute('aria-invalid');
                    if (error) error.textContent = '';
                }
            });
        }

        clearErrorOnInput(emailInput, 'email', function (val) {
            const v = val.trim();
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return emailRegex.test(v);
        });

        clearErrorOnInput(phoneInput, 'phone', function (val) {
            const digits = val.replace(/\D/g, '');
            return digits.length === 8;
        });

        clearErrorOnInput(regPwdInput, 'password', function (val) {
            const hasLength = val.length >= 8;
            const hasDigit  = /\d/.test(val);
            const hasUpper  = /[A-ZА-ЯЇІЄЎҐ]/u.test(val);
            return hasLength && hasDigit && hasUpper;
        });
    }

    const loginForm = document.querySelector('.woocommerce-form-login');
    if (loginForm) {
        const loginInput = loginForm.querySelector('#username');
        const loginPwd   = loginForm.querySelector('#password');

        function clearLoginError(input, name) {
            if (!input) return;
            input.addEventListener('input', function () {
                const error = loginForm.querySelector(`[data-error-for="${name}"]`);
                if (input.value.trim()) {
                    input.removeAttribute('aria-invalid');
                    if (error) error.textContent = '';
                }
            });
        }

        clearLoginError(loginInput, 'login');
        clearLoginError(loginPwd,   'password');
    }
});
